// frontend/src/services/api.js
import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_URL || '/api';
const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});
// Attach JWT to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);
export const authAPI = {
  login: (credentials) => api.post('/login', credentials),
};
export const customerAPI = {
  search:  (q)  => api.get('/customers/search', { params: { q } }),
  getById: (id) => api.get(`/customers/${id}`),
  updateMobile: (payload) =>
    api.put('/customers/update-mobile', payload),
};
export const serviceAPI = {
  getByCoupon: ({ couponNo, mobile }) =>
    api.get('/customer/services', {
      params: { couponNo, mobile },
    }),
  claimServices: (payload) => api.post('/services/claim', payload),
  downloadReceipt: ({ couponNo, mobile, services }) =>
    api.get('/services/receipt', {
      params: {
        couponNo,
        mobile,
        services: Array.isArray(services) ? services.join(',') : undefined,
      },
      responseType: 'blob',
    }),
};
export const couponAPI = {
  cancel:     (payload) => api.post('/coupons/cancel',     payload),
  inactive:   (payload) => api.post('/coupons/inactive',   payload),
  reactivate: (payload) => api.post('/coupons/reactivate', payload),
  getAudit: ({ couponNo, mobile }) =>
    api.get('/coupons/audit', {
      params: { couponNo, mobile },
    }),
  // NEW: Download Coupon PDF — streams the PDF binary as a blob so it can
  // be saved by the browser. Matches CustomerDetail.jsx's
  // handleDownloadCoupon(): couponAPI.downloadCoupon({ couponNo, mobile })
  // Still commented out in the UI — left untouched, under development.
  downloadCoupon: ({ couponNo, mobile }) =>
    api.get('/coupons/download', {
      params: { couponNo, mobile },
      responseType: 'blob',
    }),
};

// NEW: Insurance Customer module — additive, does not touch any Workshop
// CRM endpoints above.
export const insuranceAPI = {
  search:  (q)  => api.get('/insurance/customers/search', { params: { q } }),
  getById: (id) => api.get(`/insurance/customers/${id}`),
  getServices: ({ coupanNo, mobile }) =>
    api.get('/insurance/services', { params: { coupanNo, mobile } }),
  claimServices: (payload) => api.post('/insurance/services/claim', payload),
  // NEW: Cancel Coupon — mirrors couponAPI.cancel, keyed on coupanNo + mobile
  // (the lookup key already used by the rest of insuranceAPI) instead of
  // couponNo + membershipNo.
  cancelCoupon: (payload) => api.post('/insurance/coupons/cancel', payload),
  // NEW: Reactivate Coupon — mirrors couponAPI.reactivate.
  reactivateCoupon: (payload) => api.post('/insurance/coupons/reactivate', payload),
  // NEW: Download Coupon PDF — mirrors couponAPI.downloadCoupon, keyed on
  // coupanNo + mobile.
  downloadCoupon: ({ coupanNo, mobile }) =>
    api.get('/insurance/coupons/download', {
      params: { coupanNo, mobile },
      responseType: 'blob',
    }),
  // NEW: Audit log for a single insurance coupon — mirrors couponAPI.getAudit.
  getAudit: ({ coupanNo }) =>
    api.get('/insurance/coupons/audit', { params: { coupanNo } }),
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
  getInsuranceStats: () => api.get('/dashboard/insurance-stats'),
};

export const uploadAPI = {
  uploadExcel: (file, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload/excel', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    });
  },
};
export default api;